import { useNavigate } from '@tanstack/react-router'

import LogoIcon from '@/assets/logo_icon.svg'
import { HelpIcon } from '@/components/icon'
import {
  Box,
  HStack,
  IconButton,
  TabsList,
  TabsRoot,
  TabsTrigger,
  Tooltip,
} from '@/components/ui'
import { EXTERNAL_LINKS } from '@/constants/externalLinks'

import { UserMenu } from './UserMenu'

export const GlobalHeader = () => {
  const navigate = useNavigate()

  return (
    <Box
      as="header"
      h="64px"
      bgColor="white"
      px={{ base: '4', desktop: '6' }}
      borderBottomWidth="1px"
      borderBottomColor="border.gray"
    >
      <HStack justifyContent="space-between" alignItems="center" h="100%">
        <HStack gap={4}>
          <LogoIcon />
          <TabsRoot
            h="64px"
            variant="line"
            defaultValue="1"
            colorPalette="blue"
          >
            <TabsList h="64px" variant="line">
              <TabsTrigger
                variant="line"
                value="1"
                h="64px"
                onClick={() => navigate({ to: '/trials' })}
              >
                試験一覧
              </TabsTrigger>
            </TabsList>
          </TabsRoot>
        </HStack>

        <HStack gap={{ base: '2', desktop: '4' }}>
          <Tooltip content="操作マニュアル">
            <a
              href={EXTERNAL_LINKS.operationManual}
              target="_blank"
              rel="noopener noreferrer"
            >
              <IconButton as="span">
                <HelpIcon />
              </IconButton>
            </a>
          </Tooltip>
          <UserMenu />
        </HStack>
      </HStack>
    </Box>
  )
}
